import React, { FC, useEffect, useState } from 'react';
import { Select, Table } from 'antd';
import { Link } from 'react-router-dom';
import { api, endpoints } from '../../../../api';
import { routerPath } from '../../../../router/routerPath';
import { CustomButton, CustomSelect, CustomTableContainer, FormBlock, GridItem } from '../../../../styles/styled';
import { NmsMeetingsResponseType, NmsMeetingsType, NmsMeetingType } from '../../../CreateNmsMeetingPage/types';
import { PaginationType } from '../../../ExpertPage/ExpertPage';

const { Option } = Select;

type NmsArchiveComponentProps = {
  nms?: boolean;
};

export const NmsArchiveComponent: FC<NmsArchiveComponentProps> = ({ nms }) => {
  const [nmsMeetingsState, setNmsMeetings] = useState<NmsMeetingsType>([]);
  const [paginationState, setPaginationState] = useState<PaginationType>({ pagination: 1, perPage: 10, count: 0 });
  const [filterState, setFilter] = useState<number | null>(null);
  const [searchState, setSearchState] = useState<boolean | undefined>(false);

  useEffect(() => {
    if (searchState === undefined) {
      setSearchState(true);

      return;
    }

    (async () => {
      try {
        const response = await api.get<NmsMeetingsResponseType>(
          searchState && filterState ? endpoints.getNmsByFilters(filterState) : endpoints.getNms(),
        );

        setPaginationState({
          ...paginationState,
          pagination: 1,
          count: response.data.nms.length === 0 ? 0 : response.data.nms.filter((el) => el.archive).length,
        });

        setNmsMeetings(
          response.data.nms
            .filter((el) => (nms ? el.archive && el.access_provided_to_members : el.archive))
            .map((el, idx) => {
              return { ...el, key: idx + 1 };
            }),
        );
      } catch (err) {}
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState, paginationState.pagination]);

  const nmsArchiveColumns = [
    {
      title: '№ п/п',
      dataIndex: 'key',
      key: 'key',
      render: (item: string) => <p style={{ width: '40px' }}> {item} </p>,
    },
    {
      title: 'Дата заседания',
      dataIndex: 'date',
      key: 'date',
      render: (date: string, nmsMaterial: NmsMeetingType) => (
        <div className="text-link align-center">
          <Link to={`/${routerPath.nmsFedInfoMeeting}/${nmsMaterial.id}`}>{date.split('-').reverse().join('-')}</Link>
        </div>
      ),
    },
  ];

  const emptyFilters = () => {
    setFilter(null);
    setSearchState(false);
  };

  return (
    <FormBlock white noBorderRadius>
      <GridItem direction="column" gap="40px" align="center" justify="center">
        <GridItem width="40%" direction="column" gap="10px" justify="flex-start" align="flex-start">
          <div className="text">Год заседания</div>
          <CustomSelect value={filterState} onChange={(value) => setFilter(value as number)}>
            <Option key={2021} value={2021}>
              2021
            </Option>
            <Option key={2022} value={2022}>
              2022
            </Option>
            <Option key={2023} value={2023}>
              2023
            </Option>
            <Option key={2024} value={2024}>
              2024
            </Option>
            <Option key={2025} value={2025}>
              2025
            </Option>
          </CustomSelect>
          <GridItem direction="row" align="center" justify="center" gap="30px">
            <CustomButton onClick={() => setSearchState(undefined)}>Найти</CustomButton>
            <CustomButton onClick={emptyFilters} lined>
              Очистить
            </CustomButton>
          </GridItem>
        </GridItem>

        <GridItem width="50%" justify="center" align="center">
          <CustomTableContainer>
            <Table
              locale={{ emptyText: 'Заседаний не обнаружено' }}
              pagination={
                paginationState.count < 10
                  ? false
                  : {
                      total: paginationState.count,
                      onChange: (value) =>
                        setPaginationState({
                          ...paginationState,
                          pagination: value,
                        }),
                      current: paginationState.pagination,
                    }
              }
              columns={nmsArchiveColumns}
              dataSource={nmsMeetingsState}
            />
          </CustomTableContainer>
        </GridItem>
      </GridItem>
    </FormBlock>
  );
};
